<template>
    <div>
        <div class="order-dialog" v-if="isShow" @click="onClose">
            <div class="order-container" @click.stop="" v-if="paidInfo">
                <van-icon class="close-btn" name="cross" @click="onClose" />
                <Step :stepItem="stepItem" :active="stepActive" />

                <div v-show="stepActive === 0">
                    <FormData ref="formData" :disabled="paidInfo.formState" :fieldList="fieldList" />
                    <div class="opts">
                        <template v-if="productInfo && productInfo.onSale">
                            <template v-if="paidInfo.formState">
                                <van-button plain type="warning" @click="onResetAgreement">重新签署</van-button>
                                <van-button plain type="primary" @click="onPreviewAgreement">查看协议</van-button>
                                <van-button @click="onSwitchStep(1)">下一步</van-button>
                            </template>
                            <van-button v-else plain color="#07c160" @click="onSubmit">提交信息</van-button>
                        </template>
                        <van-button disabled v-else>商品已售罄</van-button>
                    </div>
                </div>

                <div v-show="stepActive === 1">
                    <Payment
                        ref="paymentInfo"
                        :productInfo="productInfo"
                        :providerList="providerList"
                        :paidInfo="paidInfo"
                    />
                    <div class="opts">
                        <van-button @click="onSwitchStep(-1)">上一步</van-button>
                        <van-button v-if="productInfo && productInfo.onSale" color="#07c160" @click="onPayment">
                            立即付款
                        </van-button>
                        <van-button disabled v-else>商品已售罄</van-button>
                    </div>
                </div>
            </div>
        </div>
        <PreviewAgm ref="previewAgm" />
        <SignAgm ref="signAgm" @onClose="onCloseSignAgm" />
        <WechatQrcode ref="wechatQrcode" @queryState="onQueryPayState" />
    </div>
</template>
<script>
import { Button } from 'vant'
import Step from './Step.vue'
import FormData from './FormData.vue'
import Payment from './Payment.vue'
import PreviewAgm from './PreviewAgm.vue'
import SignAgm from './SignAgm.vue'
import WechatQrcode from './WechatQrcode'
import { isWeixin, isMobile } from '@/utils/utils'
import { getPayInfo, fetchOrder, getPayType, signAgreement, wxPay, getPaidStatus } from '@/utils/api.js'
const QRCode = require('qrcode')

const _localStorageKey = 'orderVerify-dialog-pay-info'
export default {
    components: { Step, FormData, Payment, PreviewAgm, SignAgm, WechatQrcode, VanButton: Button },
    data() {
        return {
            isShow: false,

            productInfo: null,
            paidInfo: null,

            // 表单字段
            fieldList: [],
            stepItem: [],
            providerList: [],

            stepActive: 0,
        }
    },
    created() {
        window.QRCode = QRCode
    },
    methods: {
        // liveId(直播ID) depositFee/depositCode(定金) productInfo(商品信息) userInfo(用户信息)
        onShow(dialogData) {
            this.dialogData = dialogData
            this.productInfo = dialogData.productInfo
            this.userInfo = dialogData.userInfo
            this.isShow = true

            this.fieldList = []
            this.stepItem = []
            this.providerList = []
            this.stepActive = 0
            this.initData()
        },
        onClose() {
            this.isShow = false
        },

        onSwitchStep(num) {
            this.stepActive += num
        },
        onPreviewAgreement() {
            this.$refs.previewAgm.onShow({
                userId: this.userInfo.id,
                archiveNo: this.paidInfo.agreement.archiveNo,
                productNo: this.productInfo.productNo,
                productType: this.productInfo.productType,
                extra: this.paidInfo.agreement.extra,
            })
        },
        onResetAgreement() {
            this.paidInfo.formState = false
        },
        onSubmit() {
            const { state, data } = this.$refs.formData.validate()
            if (!state) return
            if (this.paidInfo.agreement.state !== -1) {
                let source = undefined
                if (this.dialogData.sn) {
                    source = { type: 'sn', value: this.dialogData.sn }
                } else if (this.dialogData.liveId) {
                    source = { type: 'live', value: this.dialogData.liveId }
                }
                this.$refs.signAgm.onShow({
                    userId: this.userInfo.id,
                    tplNo: this.paidInfo.agreement.tplNo,
                    productNo: this.productInfo.productNo,
                    productType: this.productInfo.productType,
                    extra: this.paidInfo.agreement.extra,
                    userExt: data,
                    source: source,
                })
            } else {
                this.stepActive = 1
            }

            // 缓存支付信息，下进来直接使用
            window.localStorage.setItem(_localStorageKey, JSON.stringify(data))
        },

        onCloseSignAgm(state, esignImg) {
            // 电子签名是否成功
            if (!state) return
            this.signAgreementApi(esignImg)
        },

        signAgreementApi(signatureBase64) {
            const { state, data } = this.$refs.formData.validate()
            if (!state) return
            const _params = {
                userId: this.userInfo.id,
                productType: this.productInfo.productType,
                productNo: this.productInfo.packageNo,
                userExt: { ...data },
                extra: this.paidInfo.agreement.extra,
            }
            if (this.paidInfo.agreement.archiveNo) {
                _params.archiveNo = this.paidInfo.agreement.archiveNo
            }

            if (this.paidInfo.agreement.tplNo) {
                _params.tplNo = this.paidInfo.agreement.tplNo
            }
            if (this.paidInfo.agreement.company && this.paidInfo.agreement.company.companyNo) {
                _params.companyNo = this.paidInfo.agreement.company.companyNo
            }
            if (signatureBase64) {
                _params.signatureBase64 = signatureBase64
            }
            signAgreement(_params).then((res) => {
                this.paidInfo.agreement.archiveNo = res.data.archiveNo
                this.paidInfo.formState = true
            })
        },

        onQueryPayState() {
            getPaidStatus({ packageNo: this.productInfo.productNo, userId: this.userInfo.id }).then((res) => {
                if (res.data && res.data.status) {
                    this.$toast.success('支付成功')
                    this.$refs.wechatQrcode.onClose()
                    this.onClose()
                } else {
                    this.$toast.fail('支付未完成')
                }
            })
        },

        onPayment() {
            const { state, data } = this.$refs.formData.validate()
            if (!state) return

            const { payType } = this.$refs.paymentInfo.getParams()
            const _params = {
                userId: this.userInfo.id,
                productType: this.productInfo.productType,
                productNo: this.productInfo.productNo,
                agreementStatus: true,
                orderDetail: { payFee: this.paidInfo.toPayFee },
                userContact: { userId: this.userInfo.id, ...data },
            }
            if (this.userInfo.openId) {
                _params.openId = this.userInfo.openId
            }

            if (this.paidInfo.agreement.archiveNo) {
                _params.archiveNo = this.paidInfo.agreement.archiveNo
            }

            _params.orderDetail.tradeProvider = payType
            if (payType === 'wxpay') {
                _params.appId = window.WX_APPID
                _params.orderDetail.tradeType = isWeixin() ? 'JSAPI' : 'NATIVE'
            } else if (payType === 'alipay') {
                _params.appId = window.ALI_APPID
                _params.orderDetail.tradeType = isMobile() ? 'wap_pay' : 'pc_pay'
            }

            if (this.dialogData.depositCode) {
                _params.orderDetail.payCode = this.dialogData.depositCode
                _params.orderDetail.payFee = this.dialogData.depositFee
            }
            // 1直播间/2邀请
            if (this.dialogData.liveId) {
                _params.sourceType = 1
                _params.sourceFrom = this.dialogData.liveId
            } else if (this.dialogData.sn) {
                _params.sourceType = 2
                _params.sourceFrom = this.dialogData.sn
            }
            this.$toast.loading()
            fetchOrder(_params).then((res) => {
                this.$toast.clear()
                // 微信支付  PC/微信
                if (_params.orderDetail.tradeProvider === 'wxpay') {
                    if (_params.orderDetail.tradeType === 'JSAPI') {
                        wxPay({ ...res.data, package: res.data.packageValue }, (data) => {
                            if (data.err_msg === 'get_brand_wcpay_request:ok') {
                                this.$toast.success('支付成功')
                                this.reloadPage()
                            } else if (data.err_msg === 'get_brand_wcpay_request:fail') {
                                this.$toast('支付失败')
                            }
                        })
                    } else if (_params.orderDetail.tradeType === 'NATIVE') {
                        this.$refs.wechatQrcode.onShow(res.data.codeUrl)
                    }
                }
                // 支付宝  PC/移动
                if (_params.orderDetail.tradeProvider === 'alipay') {
                    if (_params.orderDetail.tradeType === 'wap_pay') {
                        window.location.href = `./alipay-guide.html?shortKey=${res.data.payShortKey}`
                    } else if (_params.orderDetail.tradeType === 'pc_pay') {
                        window.location.href = res.data.sourceValue
                    }
                }
            })
        },

        async initData() {
            const _params = {
                productNo: this.productInfo.productNo,
                userId: this.userInfo.id,
                productType: this.productInfo.productType,
            }
            if (this.dialogData.depositCode) {
                _params.payCode = this.dialogData.depositCode
            }
            const _res = await Promise.all([getPayInfo(_params), getPayType()])
            if (_res[0]['data']['status']) {
                this.$toast('已购买')
                this.onClose()
                return
            }


            // 初始化签约/提交状态 formState,  archiveNo有值则意味着已提交
            _res[0]['data']['formState'] = _res[0]['data']['agreement']['archiveNo']
            this.paidInfo = _res[0]['data']

            this.fieldList = [
                { val: '', key: 'name' },
                { val: '', key: 'telNo' },
            ]
            if (this.paidInfo.agreement.state !== -1) {
                this.fieldList.push({ val: 'idcard', key: 'certType' })
                this.fieldList.push({ val: '', key: 'certNo' })
            }
            // 设置默认填写信息
            let _fieldData = window.localStorage.getItem(_localStorageKey)
            try {
                if (_fieldData) {
                    _fieldData = JSON.parse(_fieldData)
                    this.fieldList.forEach((i) => {
                        i.val = _fieldData[i.key] || i.val
                    })
                }
            } catch (error) {
                console.log(error)
            }

            // 初始化提交信息
            if (this.paidInfo.agreement.userExt) {
                this.fieldList.forEach((i) => {
                    i.val = this.paidInfo.agreement.userExt[i.key] || ''
                })
            }

            this.initStepItem()
            this.initProviderList(_res[1]['data'])
        },
        // 初始化 step
        initStepItem() {
            const _stepItem = []
            if (this.paidInfo.agreement.state !== -1) {
                _stepItem.push({ name: '签署协议', val: 0 })
            } else {
                _stepItem.push({ name: '填写信息', val: 0 })
            }
            _stepItem.push({ name: '支付费用', val: 1 })
            this.stepItem = _stepItem

            // 已提交信息
            if (this.paidInfo.agreement.archiveNo) {
                this.stepActive = 1
            }
        },
        // 初始化 providerList
        initProviderList(data) {
            const _list = []
            if (data.indexOf('wxpay') > -1) {
                if (isWeixin() || !isMobile()) {
                    _list.push({ name: '微信', val: 'wxpay' })
                }
            }
            if (data.indexOf('alipay') > -1) {
                _list.push({ name: '支付宝', val: 'alipay' })
            }
            this.providerList = _list
        },

        reloadPage() {
            setTimeout(() => {
                window.location.reload()
            }, 1500)
        },
    },
}
</script>
<style lang="scss">
.order-dialog {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
}

.order-container {
    width: 640px;
    background: #fff;
    border-radius: 4px;
    padding: 48px 0 16px;
    box-sizing: border-box;
    position: relative;
    .close-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 16px;
        font-size: 24px;
        cursor: pointer;
    }
}

.opts {
    display: flex;
    max-width: 560px;
    margin: 28px auto;
    justify-content: space-evenly;
    .van-button {
        height: 40px;
        padding: 0 18px;
        border-radius: 4px;
        flex-shrink: 0;
    }
}

@media screen and (max-width: 900px) {
    .order-dialog {
        align-items: flex-end;
    }
}
</style>
